import { render, staticRenderFns } from "./LiveSocialDownloadButton.vue?vue&type=template&id=49a5199e&scoped=true&"
import script from "./LiveSocialDownloadButton.vue?vue&type=script&lang=ts&"
export * from "./LiveSocialDownloadButton.vue?vue&type=script&lang=ts&"
import style0 from "./LiveSocialDownloadButton.vue?vue&type=style&index=0&id=49a5199e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5199e",
  null
  
)

export default component.exports